import { makeRequest, Service, identify } from 'utils/http';
import { CreateWarehouseRequest } from 'trace-backend-sdk';

export async function createWarehouseAPI(warehouse: CreateWarehouseRequest) {
  return makeRequest(Service.createWarehouse(warehouse, await identify()));
}
